import { render, staticRenderFns } from "./FlatRoofPrintPage2.vue?vue&type=template&id=2300b64f"
import script from "./FlatRoofPrintPage2.vue?vue&type=script&lang=js"
export * from "./FlatRoofPrintPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports